import {analyticsHandler} from '#/analytics/analytics';
import {useEffect} from 'react';
import {useLocation} from 'react-router';

export const useTrackAnalyticsPage = () => {
  const location = useLocation();
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    analyticsHandler.page(params);
  }, [location]);
};
